import { useEffect, useState } from 'react';
import authService from '../services/authService';

export function useAuthValidation() {
    const [isValidating, setIsValidating] = useState(true);
    const [isValid, setIsValid] = useState(false);

    useEffect(() => {
        async function validateToken() {
            // Si pas de token, pas besoin de valider
            if (!authService.isAuthenticated()) {
                setIsValidating(false);
                setIsValid(false);
                return;
            }

            try {
                // Appeler /api/auth/me pour valider le token
                const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:7071/api'}/auth/me`, {
                    headers: {
                        'Authorization': `Bearer ${authService.getToken()}`
                    }
                });

                if (response.ok) {
                    setIsValid(true);
                } else {
                    // Token invalide, déconnecter
                    authService.logout();
                    setIsValid(false);
                }
            } catch (error) {
                // Erreur réseau ou backend down, on nettoie quand même
                console.error('Token validation failed:', error);
                authService.logout();
                setIsValid(false);
            } finally {
                setIsValidating(false);
            }
        }

        validateToken();
    }, []);

    return { isValidating, isValid };
}
